import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Grid, Stack } from '@mui/material'
import { useGridApiRef } from '@mui/x-data-grid-pro'
import BasicDataGrid from 'components/generic/datagrid'
import InventorySummaryBar from 'components/layouts/InventorySummaryBar'
import DialogModal from '.'

const FinishedGoodsViewModal = ({ finishedGoodsList, onSave, ...restProps }) => {
  const apiRef = useGridApiRef()

  const { defaultYardUm } = useSelector(state => state.settings)
  const { enablePullApartFeatures } = useSelector(state => state.featureFlags?.variables || {})

  const fgColumns = useMemo(() => {
    const columns = [
      {
        field: 'fgTag',
        headerName: 'FG #',
        flex: 1,
        editable: false,
        sortable: false,
      },
      {
        field: 'materialCode',
        headerName: 'Material Code',
        flex: 1,
        editable: false,
        sortable: false,
      },
      {
        field: 'materialName',
        headerName: 'Material Name',
        width: 200,
        editable: false,
        sortable: false,
      },
      {
        field: 'package',
        headerName: 'Package',
        flex: 1,
        editable: false,
        sortable: false,
      },
      {
        field: 'itemCount',
        headerName: 'Count',
        flex: 1,
        editable: false,
        sortable: false,
      },
      {
        field: 'netWeight',
        headerName: 'Net Weight',
        flex: 1,
        renderCell: params => `${params?.row?.netWeight} ${defaultYardUm}`,
        sortable: false,
      },
    ]
    const filteredColumns = columns.filter(column => {
      if (!enablePullApartFeatures && column.field === 'itemCount') return false
      return true
    })
    return filteredColumns
  }, [defaultYardUm, enablePullApartFeatures])

  const summaryItems = [
    {
      label: 'DATE CREATED',
      value: `${finishedGoodsList[0]?.plDate}`,
    },
    {
      label: 'TOTAL NET WEIGHT',
      value: `${finishedGoodsList.reduce(
        (acc, next) => acc + Number(next?.netWeight ? next?.netWeight : 0),
        0,
      )} ${defaultYardUm}`,
    },
    {
      label: 'TOTAL FINISHED GOODS',
      value: finishedGoodsList.length,
    },
    {
      label: 'NOTES',
      value: '',
    },
  ]

  return (
    <DialogModal
      {...restProps}
      title={`Packing List #${finishedGoodsList[0]?.plTag}`}
      closeVisible={false}
      onSave={() => onSave()}
    >
      <Stack sx={{ height: 450 }}>
        <InventorySummaryBar items={summaryItems} isGrayBg={false} />
        <Grid p={3} sx={{ height: '100%', overflow: 'scroll' }} container flexDirection="column">
          <BasicDataGrid
            density="compact"
            height="auto"
            rows={finishedGoodsList}
            columns={fgColumns}
            apiRef={apiRef}
            editMode="row"
            disableColumnMenu
            hideFooter
          />
        </Grid>
      </Stack>
    </DialogModal>
  )
}

FinishedGoodsViewModal.propTypes = {
  ...DialogModal.propTypes,
  finishedGoodsList: PropTypes.arrayOf(PropTypes.object),
}

FinishedGoodsViewModal.defaultProps = {
  ...DialogModal.defaultProps,
  finishedGoodsList: [],
}

export default FinishedGoodsViewModal
